import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Offcanvas,
  Spinner,
} from "react-bootstrap";
import { Form } from "react-bootstrap";
import { easeOut, motion } from "framer-motion";
import AnimatedCursor from "react-animated-cursor";


import { ExternalLink } from "react-external-link";

import "./HeroSection.css";

import Maimage from "../assets/Maimage.png";
import { useState, useEffect } from "react";

function HeroSection() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [isLoading, setIsLoading] = useState(false);

  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isValidEmail] = useState(true);
  const navigate = useNavigate();

  const validateEmail = (input) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);

  const specialize = ["UI-design","UX-design", "Frontend-dev","Branding", "No-code dev"];

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
  
    if (!validateEmail(email)) {
      alert("Please enter a valid email address.");
      setIsLoading(false);
      return;
    }
  
    try {
      const response = await axios.post("https://formspree.io/f/xknlwkza", {
        fullname,
        email,
        message,
      }, {
        headers: { "Accept": "application/json" }
      });
  
      if (response.status === 200) {
       
        setFullname("");
        setEmail("");
        setMessage("");
        handleClose()
        navigate("/formsubmission", { replace: true });
      } else {
        throw new Error("Failed to submit form");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      alert("Failed to submit the form. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <Container fluid className="herosection">
      <Row id="hero">
        <Col xs={12} md={6} lg={6}>
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: -5, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <div className="HerosectionText">
              <h1 className="myname">I'm Yinka Oluwasegun</h1>
              <p
                id="mynameparagraph"
                style={{
                  lineHeight: 26 + "PX",
                  fontSize: 0.8 + "rem",
                  marginTop: 1 + "rem",
                }}
              >
                As a{" "}
                <span
                  style={{
                    background: "#1C1B1B",
                    color: "white",
                    fontWeight: "bolder",
                    padding: 2,
                    margin: 2,
                  }}
                >
                  {" "}
                  UI/UX Engineer
                </span>
                I streamline complex problems into user-friendly product
                interfaces by blending diverse design skills and perspectives
                for a user-centered approach.
              </p>
             <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', gap: '8px' }}>
              {specialize.map((x, i) => (
                <div
                  key={i}
                  style={{
                    fontSize: "0.8rem",
                    padding: "3.5px 12px",
                    backgroundColor: "rgba(0, 0, 0, 0.05)", // light faded bg
                    borderRadius: "80px",
                  }}
                >
                  {x}
                </div>
              ))}
            </div>

              <div style={{ marginTop: 1.1 + "rem" ,display: 'flex', flexWrap: 'wrap', gap: '1rem'}}>
                <ExternalLink
                  style={{ textDecoration: "none", Color: "black" }}
                  href="https://www.linkedin.com/in/akinseye-oluwasegun-yinka-319a661a9/"
                >
                  <span
                    style={{
                     
                      color: "black",
                      fontWeight: "400",
                       fontFamily: 'Jost, sans-serif',
                       fontSize: "0.75rem",
                    }}
                  >
                    LINKEDIN
                  </span>
                </ExternalLink>

               

                <ExternalLink
                  style={{ textDecoration: "none", Color: "black" }}
                  href="https://github.com/olayinka02"
                >
                  <span
                    style={{
                    
                      color: "black",
                      fontWeight: "400",
                       fontFamily: 'Jost, sans-serif',
                        fontSize: "0.75rem",
                    }}
                  >
                    GITHUB
                  </span>
                </ExternalLink>

                <ExternalLink
                  style={{ textDecoration: "none", Color: "black" }}
                  href="https://www.instagram.com/0layimmika/"
                >
                  <span
                    style={{
                     
                      color: "black",
                      fontWeight: "400",
                       fontFamily: 'Jost, sans-serif',
                        fontSize: "0.75rem",
                    }}
                  >
                    INSTAGRAM
                  </span>
                </ExternalLink>

                <ExternalLink
                  style={{ textDecoration: "none", Color: "black" }}
                  href="https://x.com/Olayimika_yinka"
                >
                  <span
                    style={{
                     
                      color: "black",
                      fontWeight: "400",
                       fontFamily: 'Jost, sans-serif',
                        fontSize: "0.75rem",
                    }}
                  >
                    X
                  </span>
                </ExternalLink>

                
              </div>
            </div>

            <Button
              className="Mobilebtn"
              onClick={handleShow}
              style={{
                borderRadius: 0.2 + "rem",
                paddingLeft: 1.1 + "rem",
                paddingRight: 1.1 + "rem",
                marginTop: 1 + "rem",
                marginBottom: 2.5 + "rem",
              }}
              variant="dark"
            >
              Contact Me
            </Button>
          </motion.div>
        </Col>
        <Col xs={12} md={6} lg={6}>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <center>
              <img
                style={{ marginLeft: -15, width: 23 + "rem" }}
                className="img-fluid abouturbanImage"
                src={Maimage}
                alt="abouturbanImage"
              />
            </center>
          </motion.div>
        </Col>
      </Row>

      <Offcanvas
        placement="bottom"
        show={show}
        onHide={handleClose}
        className="contactmodal"
      >

         {!isSmallScreen && (
                <AnimatedCursor
                  innerSize={5}
                  outerSize={36}
                  color='95,95,95'
                  outerAlpha={0.25}
                  innerScale={0.7}
                  outerScale={1.5}
                  outerStyle={{ border: '1.5px solid #4A4A4A' }}
                  innerStyle={{ border: '4px solid #ffffff' }}
                  trailingSpeed={10}
                  clickables={[
                    'a', 'input[type="text"]', 'input[type="email"]', 'input[type="number"]', 'input[type="submit"]',
                    'input[type="image"]', 'label[for]', 'select', 'textarea', 'button', '.link'
                  ]}
                />
              )}
       
        <Offcanvas.Header closeButton closeVariant="white">

          <Offcanvas.Title style={{ fontSize: 0.7 + "rem", color: "#707070" }}>
            CONTACT ME
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: -2 }}
              transition={{
                duration: 0.3,
                delay: 0.2,
                timingFunction: easeOut,
              }}
            >
              <h2
                style={{
                  color: "whitesmoke",
                  fontWeight: "bold",
                  wordSpacing: 2.5,
                }}
              >
                Get in touch with me
              </h2>
              <p style={{ color: "whitesmoke", wordSpacing: 2.5 }}>
                Provide the follow details{" "}
              </p>
            </motion.div>

            <Form
              onSubmit={handleSubmit}
              style={{  fontFamily: 'Jost, sans-serif', fontSize: "0.8rem" }}
            >
              <Form.Group className="mb-3">
                <Form.Label style={{ color: "#FFFFFF" }}>Fullname</Form.Label>
                <Form.Control
                  type="text"
                  value={fullname}
                  onChange={(e) => setFullname(e.target.value)}
                  required
                  placeholder="Enter your fullname"
                  style={{ borderRadius: "0rem" }}
                  isInvalid={!isValidEmail}
                />
                {!isValidEmail && (
                  <Form.Control.Feedback type="invalid">
                    Please enter a valid email address.
                  </Form.Control.Feedback>
                )}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label style={{ color: "#FFFFFF" }}>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Enter your mail"
                  style={{ borderRadius: "0rem" }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label style={{ color: "#FFFFFF" }}>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  placeholder="Enter your message"
                  rows={3}
                  style={{ borderRadius: "0rem" }}
                />
              </Form.Group>
              <Button
                type="submit"
                className="submitbtn"
                style={{
                paddingLeft: "2rem",
                paddingRight: "2rem",
                fontFamily: "Jost, sans-serif",
              
                borderRadius: "0rem",

                  background:
                      "radial-gradient(70.4% 63.2% at 53.1% 128.2%, rgba(255, 255, 255, 0.23) 0%, rgba(255, 255, 255, 0.04) 100%)",
                    height: "100%",
                  
                    boxShadow:
                      "rgba(255, 255, 255, 0.024) 0px 0.362176px 0.651917px -1px inset, rgba(255, 255, 255, 0.035) 0px 3px 5.4px -2px inset",
                    willChange: "auto",
                    opacity: 1,
                    borderBottomWidth: "2px",
                    borderLeftWidth: "2px",
                    borderRightWidth: "2px",
                    borderTopWidth: "2px",
                    borderColor: "rgba(255, 255, 255, 0.02)",
                    borderStyle: "solid",
              }}
                variant="dark"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    <span
                      style={{
                        fontSize: "0.8rem",
                        marginLeft: "0.3rem",
                        marginRight: "0.3rem",
                      }}
                    >
                      Loading...
                    </span>
                  </>
                ) : (
                  <span
                    style={{
                      fontSize: "0.8rem",
                      marginLeft: "0.3rem",
                      marginRight: "0.3rem",
                    }}
                  >
                    SUBMIT
                  </span>
                )}
              </Button>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}

export default HeroSection;
